import ConditionalRenderer from '@/components/ConditionalRenderer'
import React from 'react'

const ButtonLoader = ({
    className,
    style,
    isLoading = true,
    width,
    height,
}: {
    className?: string
    isLoading?: boolean
    style?: { [key: string]: string | number }
    width?: number
    height?: number
}) => {
    return <ConditionalRenderer condition={isLoading}>
        <span
            data-testid='button-loader'
            className={`spinner-border spinner-border-sm ${className}`}
            style={{
                ...style,
                width: width,
                height: height,
            }}
            aria-hidden='true'
        />
    </ConditionalRenderer>
}

export default ButtonLoader
